import axios from './api';
import { getQueryData, getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/prm';

export const getPRMs = async ({ page, size, filters }) => {
  if (filters.pid) {
    filters['pre_delivery_note_data.project'] = filters.pid;
    delete filters.pid;
  }
  return axios
    .get(endPoint.concat(getQueryData(page, size, filters)), {})
    .then((response) => response)
    .catch((error) => error.response);
};

export const getPRM = async (id) => {
  return axios
    .get(endPoint.concat(`/${id}`), {})
    .then((response) => response)
    .catch((error) => error.response);
};

export const deletePRM = (id) =>
  axios
    .delete(endPoint.concat(`/${id}`))
    .then((response) => response)
    .catch((error) => error.response);
